import { render, staticRenderFns } from "./common.page.vue?vue&type=template&id=9fee5362&scoped=true&"
import script from "./common.page.vue?vue&type=script&lang=ts&"
export * from "./common.page.vue?vue&type=script&lang=ts&"
import style0 from "./common.page.vue?vue&type=style&index=0&id=9fee5362&lang=scss&scoped=true&"
import style1 from "./common.page.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fee5362",
  null
  
)

export default component.exports